const ENV = {
    development: {
        apiURL: 'http://localhost:1337',
    },
    production: {
        apiURL: process.env.REACT_APP_API_URL || 'https://admin.xiahlegends.com',
    },
};

const getEnvironmentVariables = () => {
    if (process.env.NODE_ENV === 'development') {
        return ENV.development;
    }

    return ENV.production;
};

export default getEnvironmentVariables();
